// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__mPf5M","employee-header-item":"Header_employee-header-item__A7-41"};